import { render } from "./CommonWrapper.vue?vue&type=template&id=5162c94e"
import script from "./CommonWrapper.vue?vue&type=script&lang=js"
export * from "./CommonWrapper.vue?vue&type=script&lang=js"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__